import { cleanTrackingUrl } from './urlHelpers.js';

$('.analytics-click').each(function(index, element) {
    function handleProductClick(event) {
        if (event.button === 2) return;
        if (event.currentTarget.dataset.analyticsdata) {
            var productObj = JSON.parse(event.currentTarget.dataset.analyticsdata);

            if (productObj) {
                if (event.currentTarget.href) {
                    productObj.url = cleanTrackingUrl(event.currentTarget.href);
                }
                dataLayer.push({
                    'event': 'productClick',
                    'ecommerce': {
                        'click': {
                            'actionField': { 'list': 'Product Rollup' },
                            'products': [productObj]
                        }
                    }
                });
            }
        }
    }
    $(element).click(handleProductClick);
    $(element).on('auxclick', handleProductClick);
});